import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import AddOrEditCatalogue from "./AddOrEditCatalogue";
import ModalCloseIcon from "../../common/Components/Icons/ModalCloseIcon";
const CatalogueModal = (props: any) => {
  const { openModal, closeModal, editData, getAllData,handleName} = props;
  return (
    <Modal
      isOpen={openModal}
      toggle={closeModal}
      size="lg"
      className="CatalogueModal"
      fade={false}
    >
      <ModalHeader>
        <div className="Heading">
          <h3>{editData?._id ? "Edit Catalogue" : "Create New Catalogue"}</h3>
          <ModalCloseIcon {...props} closeModal={closeModal} />
        </div>
      </ModalHeader>
      <ModalBody>
        <AddOrEditCatalogue
          {...props}
          closeModal={closeModal}
          editData={editData}
          getAllData={getAllData}
          handleName={handleName}
        />
      </ModalBody>
    </Modal>
  );
};

export default CatalogueModal;
